<template>
	<div class="power-data" >
		<div class="transformer-data" v-if="routeName === 'Transformer'">
			<div class="tab">
        <span
		        style="cursor: pointer"
		        @click="transformerTab = 0"
		        :class="{ active: transformerTab === 0 }"
        >变压器监测</span
        >
				<span
						style="cursor: pointer"
						@click="transformerTab = 1"
						:class="{ active: transformerTab === 1 }"
				>负载率分析</span
				>
			</div>

			<template v-for="(cardDataList, cardListIndex) in cardData">
				<div
						class="card-list row-center"
						:key="cardListIndex"
						v-if="transformerTab === cardListIndex"
						style="justify-content: space-between"
				>
					<div
							v-for="(item, index) in cardDataList"
							:key="index"
							:class="'type-' + item.type"
							class="card-item column-center"
							style="justify-content: space-evenly"
					>
						<template v-if="item.type === '1' || item.type === '4'">
							<div
									class="column-center"
									v-for="(subItem, i) in item.details"
									:key="index + '-' + i"
							>
								<h5>{{ subItem.title }}</h5>
								<span>
                  {{
                    subItem.func
                      ? subItem.func(subItem)
                      : mqttval(subItem.value)
                  }}
                  <span style="font-size: 25rem">{{ subItem.unit }}</span>
                </span>
							</div>
						</template>
						<template v-if="item.type === '1' || item.type === '4'">
							<div
									class="row-center other"
									v-for="(other, otherIndex) in item.otherInfo"
									:key="otherIndex"
							>
                <span style="font-size: 16rem; color: #999; font-weight: 400">{{
                  other.title + "：" + other.value() + other.unit
                }}</span>
							</div>
						</template>
						<template v-if="item.type === '2'">
							<h5>{{ item.title }}</h5>
							<span v-html="item.desc(item)"></span>

							<div class="row-center val-details">
                <span
		                v-for="(valItem, valIndex) in item.details"
		                :key="valIndex"
                >
                  <span style="color: #000 !important"
                  >{{ valItem.title }}：</span
                  >
                  <span style="color: #0d94ff !important">{{
                    mqttval(valItem.value) + valItem.unit
                  }}</span>
                </span>
							</div>
							<div style="margin-top: 30rem">
                <span
		                style="
                    color: rgba(153, 153, 153, 1);
                    font-size: 18rem;
                    font-weight: 400;
                  "
                >风机状态:
                </span>
								<span v-html="item.fandesc(item)"></span>
							</div>
						</template>
						<template v-if="item.type === '3'">
							<!-- <div style="position: absolute;top:10%;left:40%;font-size:20rem">高中低</div>黎威 -->
							<h4
									:style="
                  'font-size:24rem' +
                    ';color:' +
                    item.func(item).color +
                    ';' +
                    (item.func(item).title === '--' ||
                    item.func(item).title === '负载正常' ||
                    item.func(item).title === '暂无数据，无法分析'
                      ? 'margin: 0 auto;'
                      : '')
                "
							>
								{{ item.func(item).title }}
								<el-dropdown
										trigger="click"
										@command="handleCommand"
										placement="bottom"
										style="cursor:pointer"
								>
                  <span class="el-dropdown-link" style="color:#333333">
                    [{{
                      loadfactor == ""
                        ? "日"
                        : loadfactor == "month"
                        ? "月"
                        : "年"
                    }}<i
		                  class="el-icon-arrow-down"
		                  style="font-size: 14px;font-weight: bold;"
                  ></i
                  >]
                  </span>
									<el-dropdown-menu slot="dropdown" class="loadfactor">
										<el-dropdown-item
												command="year"
												:class="loadfactor == 'year' ? 'active' : ''"
										>年
										</el-dropdown-item
										>
										<el-dropdown-item
												command="month"
												:class="loadfactor == 'month' ? 'active' : ''"
										>月
										</el-dropdown-item
										>
										<el-dropdown-item
												command=""
												:class="loadfactor == '' ? 'active' : ''"
										>日
										</el-dropdown-item
										>
									</el-dropdown-menu>
								</el-dropdown>
							</h4>

							<div class="info">
								<div
										v-for="(info, index) in item.func(item).infos"
										:key="index"
										class="info-details column-center"
										style="align-items: flex-start"
								>
									<h5 class="sub-title" v-if="info.title">
										{{ info.title }}：
									</h5>
									<p v-for="(p, pIndex) in info.list" :key="pIndex">
										{{ pIndex + 1 }}.{{ p }}
									</p>
								</div>
							</div>
						</template>
					</div>
				</div>
			</template>
		</div>
		<div
				:class="'breaker-data-' + breakerNum"
				:style="routeName === 'Breaker' ? 'padding-top: 0 !important;' : ''"
				class="real-data"
				v-else
		>
			<div
					class="tab-breaker row-center"
					style="justify-content: flex-start"
					v-if="routeName === 'Breaker' || routeName === 'CircuitBreakerAging'"
			>
				<div
						style="cursor: pointer"
						:class="{ active: breakerNum === 0 }"
						@click="breakerNum = 0"
				>
					计量监测
				</div>
				<div
						style="cursor: pointer"
						:class="{ active: breakerNum === 1 }"
						@click="breakerNum = 1"
				>
					<!-- 老化监测 -->
				</div>
			</div>

			<div class="tit" v-else>
				实时数据
				<div class="location-right" v-if="routeName === 'PowerQuality'">
					<div v-if="fow > 4" class="location-and">
						<div class="location-img">
							<img src="../../assets/img/error-yellow.png" alt=""/>
						</div>
						<div class="location-orag">电流、电压谐波超出允许范围!</div>
					</div>
					<div v-else class="location-title">当前谐波在允许范围内</div>
					<div class="location-item">
						谐波对供电线路产生了附加损耗，造成电能的浪费；影响各种电气设备的正常工作，造成设备损坏，甚至引起严重的责任事故；对危害其他系统及电力用户。
					</div>
				</div>
			</div>
			<div v-show="breakerNum === 0" class="total-data">
				<div
						class="row-center breaker"
						style="justify-content: flex-start"
						v-if="routeName === 'Breaker'"
				>
					<!-- 鲁泰项目 -->
					<!-- 断路器 -->
					<div
							class="row-center breaker1"
							v-if="$store.state.project.currentProject.projectId == 4"
					>
						<div>
							<!-- <span class="ored"
                            v-if=" getLoopLTStatus(currentLoop) === 'True'||Number(getLoopLTStatus(currentLoop)) > 0">合闸</span>
                        <span class="oglad"
                            v-else-if="getLoopLTStatus(currentLoop) == 'False'||Number(getLoopLTStatus(currentLoop)) <= 0">分闸</span>
                        <span v-else class="obalck">--</span> -->
							<span class="k">分合状态：</span>
							<span
									class="ored"
									v-if="
                  getBreakerLTStatus(currentLoop) === 'True' ||
                    Number(getBreakerLTStatus(currentLoop)) > 0
                "
							>合闸</span
							>
							<span
									class="oglad"
									v-else-if="
                  getBreakerLTStatus(currentLoop) == 'False' ||
                    Number(getBreakerLTStatus(currentLoop)) <= 0
                "
									style="color:#68d86a"
							>分闸</span
							>
							<span class="obalck" v-else>--</span>
						</div>
						<div class="sate">
							<span class="k">手车位置：</span>
							<span class="Handcart">- -</span>
						</div>
					</div>
					<div class="row-center breaker1" v-else>
						<div>
							<span class="k">分合状态：</span>
							<span
									class="v"
									v-if="typeof getBreakerStatus(currentLoop) === 'undefined'"
							>--</span
							>
							<span class="v" v-else-if="!getBreakerStatus(currentLoop)"
							>分闸
              </span>
							<span class="v" v-else>合闸</span>
						</div>
						<div class="sate">
							<span class="k">手车位置：</span>
							<span class="Handcart">- -</span>
						</div>
					</div>
				</div>
				<!-- 谐波分析 -->
				<div class="total-item" v-else-if="routeName === 'PowerQuality'"></div>
				<div class="breaker" v-else>
					<div class="Loopst">
						回路名称:<span v-if="currentLoop.uniaxial" style="margin-left:10px"
					>{{ currentLoop.loopName }}(单相)</span
					>
						<span v-else style="margin-left:10px">{{
              currentLoop.loopName
            }}</span>
					</div>
					<div
							class="breaker2"
							v-if="$store.state.project.currentProject.projectId == 4"
					>
						当前状态:
						<span
								class="ored"
								v-if="
                getLoopLTStatus(currentLoop) === 'True' ||
                  Number(getLoopLTStatus(currentLoop)) > 0
              "
						>合闸</span
						>
						<span
								class="oglad"
								v-else-if="
                getLoopLTStatus(currentLoop) == 'False' ||
                  Number(getLoopLTStatus(currentLoop)) <= 0
              "
						>分闸</span
						>
						<span v-else class="obalck">--</span>
					</div>

					<div class="breaker2" v-else>
						当前状态:
						<span v-if="typeof getLoopStatus(currentLoop) === 'undefined'"
						>--</span
						>
						<span
								v-else-if="getLoopStatus(currentLoop) == '0'"
								class="total-data-open"
						>分闸</span
						>
						<span v-else class="total-data-close">合闸</span>
					</div>
				</div>
			</div>
			<div
					v-show="breakerNum === 0"
					class="row-center"
					style="justify-content: space-between"
			>
				<div
						class="data"
						:class="routeName + '-' + tag"
						v-for="(item, index) in realData"
						:key="index"
				>
					<div v-if="routeName === 'PowerQuality'">
						<template v-if="index < 2">
							<div class="name">{{ item.type }}</div>
							<div class="details">
								<template v-if="routeName === 'PowerQuality' && tag === 'none'">
									<template v-for="detail in item.details">
										<div
												class="row-center row"
												style="justify-content: flex-start"
												v-for="(v, k) in detail.data"
												:key="k"
										>
											<div :class="{ alarming: isAlarm(v) }" class="key">
												{{ k }}
											</div>
											<div
													:class="{ alarming: isAlarm(v) }"
													class="val row-center"
													style="justify-content: space-between"
											>
                        <span>{{
                          mqttval(v, detail.multiple) +
                            (detail.unit ? `${detail.unit}` : "")
                        }}</span>
											</div>
										</div>
									</template>
								</template>
								<template v-else>
									<div
											class="row-center row"
											style="justify-content: flex-start"
											v-for="(val, key) in item.details"
											:key="key"
									>
										<div class="key">
											{{ val.key + (val.unit ? `(${val.unit}):` : ":") }}
										</div>
										<div
												v-if="Object.keys(val.data).length === 1"
												class="val row-center"
												style="justify-content: space-between"
										>
                      <span :class="{ alarming: isAlarm(v) }">{{
                        mqttval(val.data[0], val.multiple)
                      }}</span>
										</div>
										<div
												v-else
												class="val row-center"
												style="justify-content: space-between"
										>
                      <span
		                      :class="{ alarming: isAlarm(v) }"
		                      v-for="(v, k) in val.data"
		                      :key="k"
                      >{{ k + ":" + mqttval(v, val.multiple) }}</span
                      >
										</div>
									</div>
								</template>
							</div>
						</template>
					</div>
					<div v-else>
						<template v-if="index < 4">
							<div v-if="currentLoop.uniaxial">
								<div class="name">{{ item.type }}</div>
								<div class="details">
									<template
											v-if="routeName === 'PowerQuality' && tag === 'none'"
									>
										<template v-for="detail in item.details">
											<div
													class="row-center row"
													style="justify-content: flex-start"
													v-for="(v, k) in detail.data"
													:key="k"
											>
												<div :class="{ alarming: isAlarm(v) }" class="key">
													{{ k }}
												</div>
												<div
														:class="{ alarming: isAlarm(v) }"
														class="val row-center"
														style="justify-content: space-between"
												>
                          <span>{{
                            mqttval(v, detail.multiple) +
                              (detail.unit ? `${detail.unit}` : "")
                          }}</span>
												</div>
											</div>
										</template>
									</template>
									<template v-else>
										<div
												class="row-center row"
												style="justify-content: flex-start"
												v-for="(val, key) in item.details"
												:key="key"
										>
											<div class="key">
												{{ val.key + (val.unit ? `(${val.unit}):` : ":") }}
											</div>
											<div
													v-if="Object.keys(val.data).length === 1"
													class="val row-center"
													style="justify-content: space-between"
											>
                        <span :class="{ alarming: isAlarm(val.data[0]) }">
                          {{ mqttval(val.data[0], val.multiple) }}</span
                        >
											</div>
											<div
													v-else
													class="val row-center"
													style="justify-content: space-between"
											>
                        <span
		                        :class="{ alarming: isAlarm(v) }"
		                        v-for="(v, k) in val.data"
		                        :key="k"
                        >{{ k + ":" + mqttval(v, val.multiple) }}</span
                        >
											</div>
										</div>
									</template>
								</div>
							</div>
							<div v-else>
								<div class="name">{{ item.type }}</div>
								<div class="details">
									<template
											v-if="routeName === 'PowerQuality' && tag === 'none'"
									>
										<template v-for="detail in item.details">
											<div
													class="row-center row"
													style="justify-content: flex-start"
													v-for="(v, k) in detail.data"
													:key="k"
											>
												<div :class="{ alarming: isAlarm(v) }" class="key">
													{{ k }}
												</div>
												<div
														:class="{ alarming: isAlarm(v) }"
														class="val row-center"
														style="justify-content: space-between"
												>
                          <span>{{
                            mqttval(v, detail.multiple) +
                              (detail.unit ? `${detail.unit}` : "")
                          }}</span>
												</div>
											</div>
										</template>
									</template>
									<template v-else>
										<div
												class="row-center row"
												style="justify-content: flex-start"
												v-for="(val, key) in item.details"
												:key="key"
										>
											<div class="key">
												{{ val.key + (val.unit ? `(${val.unit}):` : ":") }}
											</div>
											<div
													v-if="Object.keys(val.data).length === 1"
													class="val row-center"
													style="justify-content: space-between"
											>
                        <span :class="{ alarming: isAlarm(val.data[0]) }">
                          {{ mqttval(val.data[0], val.multiple) }}</span
                        >
											</div>
											<div
													v-else
													class="val row-center"
													style="justify-content: space-between"
											>
                        <span
		                        :class="{ alarming: isAlarm(v) }"
		                        v-for="(v, k) in val.data"
		                        :key="k"
                        >{{ k + ":" + mqttval(v, val.multiple) }}</span
                        >
											</div>
										</div>
									</template>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
			<CircuitBreakerAging v-show="breakerNum === 1"></CircuitBreakerAging>
		</div>
		<div
				v-show="breakerNum === 0"
				class="diagram"
				:class="{ transformerClass: routeName === 'Transformer' }"
		>
			<div
					v-if="routeName === 'Breaker'"
					class="select row-center"
					style="justify-content: flex-start"
			>
				<el-checkbox
						style="margin-top: 14rem"
						label="切换为数据列表"
						name="type"
						@change="diagramSelected = diagramSelected === 0 ? 1 : 0"
				></el-checkbox>
			</div>
			<div v-else class="select row-center" style="justify-content: flex-start">
				<div
						:class="{ active: diagramSelected === 0 }"
						@click="diagramSelected = 0"
						v-if="routeName === 'PowerQuality'"
				>
					谐波含量
				</div>
				<div
						:class="{ active: diagramSelected === 0 }"
						@click="diagramSelected = 0"
						v-else
				>
					历史曲线
				</div>
				<div
						:class="{ active: diagramSelected === 1 }"
						@click="diagramSelected = 1"
				>
					数据列表
				</div>
			</div>
			<div
					class="content row-center"
					style="justify-content: space-between;padding-right: 24px;"
			>
				<div class="row-center">
					<el-date-picker
							:editable="false"
							:picker-options="pickerOptions"
							:clearable="false"
							class="dateSelect"
							v-model="date"
							type="date"
							:placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
					>
					</el-date-picker>
					<template v-if="routeName === 'PowerQuality'">
						<el-select
								style="width: 120px !important"
								class="node-select"
								v-model="k1"
								placeholder="请选择"
						>
							<!-- 谐波 -->
							<el-option label="电压" :value="0"></el-option>
							<el-option label="电流" :value="1"></el-option>
						</el-select>
						<el-select
								style="width: 120px !important"
								class="node-select"
								v-model="k2"
								placeholder="请选择"
						>
							<el-option label="总谐波" :value="0"></el-option>
							<el-option
									v-for="i in singular"
									:key="i"
									:value="i + 1"
									:label="i + 2 + '次'"
							>
							</el-option>
						</el-select>
					</template>
					<el-select
							class="node-select"
							v-model="node"
							placeholder="请选择"
							v-else
					>
						<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
						>
						</el-option>
					</el-select>
					<!--<div class="btn">查询</div>-->
					<div class="btn per" @click="perD">上一日</div>
					<el-button
							class="btn next"
							plain
							@click="nextD"
							:disabled="nextDayDisabled"
					>下一日
					</el-button
					>
					<!-- <div class="btn next" @click="nextD" :disabled="nextDayDisabled">下一日</div> -->
				</div>
				<div class="row-center">
					<div class="max">
						<el-checkbox
								v-if="diagramSelected === 0"
								label="最值分析"
								name="type"
								v-model="showMax"
						>
						</el-checkbox>
					</div>
					<div class="export ">
						<img
								style="width: 14px; height: 14px"
								src="../../assets/img/export.png"
								alt=""
						/>
						<span
								v-show="diagramSelected === 0"
								style="font-size: 14px; cursor: pointer"
								@click="exportFunc"
						>导出图表</span
						>
						<span
								v-show="diagramSelected === 1"
								style="font-size: 14px; cursor: pointer"
								@click="exportFunc"
						>导出报表</span
						>
					</div>
				</div>
			</div>
			<div
					class="echarts row-center"
					style="justify-content: space-between"
					:class="{ showMax }"
					v-show="diagramSelected === 0"
			>
				<div class="left row-center" style="margin-top:20rem">
					<Curve
							v-if="
              diagramData && canvasData && canvasShow && allTimes.length !== 0
            "
							:chartsData="diagramData"
					></Curve>
					<img v-else src="../../assets/img/not_found_data.png" alt=""/>
				</div>
				<div
						v-show="showMax"
						class="max-right row-center"
						style="justify-content: space-between"
						v-if="diagramData"
				>
					<div
							class="row-max row-center"
							style="justify-content: space-between"
							v-for="(item, index) in diagramData.legend.data"
							:key="index"
					>
						<div class="max-name row-center">{{ formateIntercept(item) }}</div>
						<div
								class="details column-center"
								style="justify-content: space-evenly"
						>
							<div
									class="row-center"
									style="width: 100%; justify-content: flex-start"
							>
								<span>最大值</span><span>{{ max(item) }}</span
							><span></span>
							</div>
							<div
									class="row-center"
									style="width: 100%; justify-content: flex-start"
							>
								<span>最小值</span><span>{{ min(item) }}</span
							><span></span>
							</div>
							<div
									class="row-center"
									style="width: 100%; justify-content: flex-start"
							>
								<span>平均值</span><span>{{ average(item) }}</span
							><span></span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab row-center" v-show="diagramSelected === 1 && tshow">
				<el-table
						v-if="tableData.length > 0 && tshow"
						:height="routeName !== 'Transformer' ? '480rem' : '430rem'"
						:data="tableData"
						style="width: 100%"
				>
					<el-table-column prop="name" :label="tabTitle.name" min-width="130">
					</el-table-column>
					<el-table-column
							prop="time"
							:label="tabTitle['time']"
							min-width="130"
					>
					</el-table-column>
					<template v-for="(item, key) in tabTitle">
						<template v-if="key !== 'name' && key !== 'time' && item">
							<el-table-column
									:key="key"
									:prop="key"
									:label="item"
									min-width="100"
							>
							</el-table-column>
						</template>
					</template>
				</el-table>
				<img v-else src="../../assets/img/not_found_data.png" alt=""/>
			</div>
		</div>
	</div>
</template>
<script>
	import Extremum from "../powerMonitor/report/Extremum";

	const echarts = require("echarts");
	import Curve from "../../chart/Curve";
	import {influx_load, INFLUX_QUERY, influx_workload, LOOP_DIAGRAM_DATA_BY_DAY,} from "../../api/power";
	import {GetSensor} from "../../api/common";
	import {floatFormat} from "../../util/MathUtil";
	import {
		dateFormat,
		dayEnd,
		dayStart,
		nextDay,
		nextMonth,
		nextYear,
		perDay,
		perMonth,
		perYear,
	} from "../../util/DateUtil";
	import exportExcel from "../../util/excel";
	import dict from "../../util/dict";
	import Running from "../powerMonitor/report/Running";
	import CircuitBreakerAging from "../powerMonitor/CircuitBreakerAging";
	import PowerTime from "../powerMonitor/report/PowerTime";
	import PowerRange from "../powerMonitor/report/PowerRange";

	export default {
		name: "PowerDataBase",
		props: {
			realData: Array,
			options: Array,
			currentLoop: Object,
			selectedLoops: Array,
		},
		components: {
			Curve,
			Extremum,
			Running,
			CircuitBreakerAging,
			PowerTime,
			PowerRange,
		},
		data() {
			let that = this;
			return {
				tshow: true,
				k1: 0,
				k2: 1,
				value: "",
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				breakerNum: 0,
				loadfactor: "",
				loadTitle: "今日",
				cardData: [
					[
						{
							type: "1",
							details: [
								{
									title: "负载率",
									value: "P",
									unit: "%",
									func: (that) => {
										let v = this.mqttval("loadFactor")
											? this.mqttval("loadFactor")
											: floatFormat(
											this.mqttval(that.value) / 10 / this.capacity,
											2
										) + " ";
										console.log(v, "vv");
										// console.log(this.$store.getters.mqttVal("T1/1AA1/XB11/P"));
										// console.log(this.currentLoop.subLoopUrl, v, this.capacity);
										if (v === "--") {
											return v;
										}
										try {
											// console.log(this.currentLoop.device_details)
											// return floatFormat(v / 10 / this.capacity, 2) + " ";
											return v;
										} catch (e) {
											return "--";
										}
									},
								},
								{
									title: "变压器容量",
									value: "",
									unit: "kVA",
									func: (that) => {
										return this.capacity + " ";
									},
								},
							],
						},
						{
							type: "1",
							otherInfo: [
								{
									title: "记录时间",
									value: () => {
										return this.influxDataLoad != undefined &&
										this.influxDataLoad.maxtime != undefined
											? dateFormat(
												"YY-mm-dd HH:MM:SS",
												new Date(this.influxDataLoad.maxtime)
											)
											: "--";
									},
									unit: "",
								},
							],
							details: [
								{
									title: "今日最大负载",
									value: "P",
									unit: "kW",
									func: (that) => {
										return this.influxDataLoad != undefined &&
										this.influxDataLoad.max != undefined
											? floatFormat(this.influxDataLoad.max / 1000, 2)
											: "--";
									},
								},
								{
									title: "今日最大负载率",
									value: "P",
									unit: "%",
									func: (that) => {
										return this.influxDataLoad != undefined &&
										this.influxDataLoad.max != undefined
											? floatFormat(
												this.influxDataLoad.max / 10 / this.capacity,
												2
											)
											: "--";
									},
								},
							],
						},
						{
							type: "1",
							details: [
								{
									title: "今日平均负载",
									value: "P",
									unit: "kVA",
									func: (that) => {
										return this.influxDataLoad != undefined &&
										this.influxDataLoad.mean != undefined
											? floatFormat(this.influxDataLoad.mean / 1000, 2)
											: "--";
									},
								},
								{
									title: "今日平均负载率",
									value: "P",
									unit: "%",
									func: (that) => {
										return this.influxDataLoad != undefined &&
										this.influxDataLoad.mean != undefined
											? floatFormat(
												this.influxDataLoad.mean / 10 / this.capacity,
												2
											)
											: "--";
									},
								},
							],
						},
						{
							type: "2",
							title: "温升",
							desc: (that) => {
								let i = 0;
								// console.log(that)
								that.details.forEach((item) => {
									let mqttval = this.mqttval(item.value);
									if (mqttval > 85) {
										i++;
									} else if (mqttval == "--") {
										i--;
									}
								});
								// console.log(i);
								if (i === 0) {
									return `<span style="color: #68D86A">正常</span>`;
								} else if (i <= -2) {
									return `<span style="color: #FD4238">--</span>`;
								} else {
									return `<span style="color: #F5AA00">超温</span>`;
								}
							},
							details: [
								{
									title: "A相",
									value: "Temperature_A",
									unit: "℃",
								},
								{
									title: "B相",
									value: "Temperature_B",
									unit: "℃",
								},
								{
									title: "C相",
									value: "Temperature_C",
									unit: "℃",
								},
							],
							fandesc: (that) => {
								// console.log(that)
								if (this.$store.state.project.currentProject.projectId == 4) {
									var value = this.mqttval("Temperature_status_windopen");
									//  console.log(value)
								} else {
									var value = this.mqttval("Fan_Status");
									//  console.log(value)
								}
								if (value == 0) {
									return `<span style="color:#999999;font-weight:400;font-size:18rem">关闭</span>`;
								} else if (value == 1) {
									return `<span style="color:#68D86A;font-weight:400;font-size:18rem">开启</span>`;
								} else {
									// return `<span style="color:#FD4238;font-weight:400;font-size:18rem">故障</span>`;
									return `<span style="color:#999999;font-weight:400;font-size:18rem">--</span>`;
								}
							},
						},
					],
					[
						{
							type: "3",
							value: "P",
							func: (that) => {
								let val =
									// this.influxDataLoad != undefined && this.influxDataLoad.allmean !=
									// undefined ?
									// floatFormat(
									//     this.influxDataLoad.allmean / 10 / this.capacity,
									//     3
									// ) :
									// 999;
									this.influxDataLoad != undefined &&
									this.influxDataLoad[this.loadfactor + "mean"] != undefined
										? floatFormat(
										this.influxDataLoad[this.loadfactor + "mean"] /
										10 /
										this.capacity,
										3
										)
										: 999;
								if (val <= 50) {
									return {
										title: "平均负载偏低",
										color: "#F5AA00",
										infos: [
											{
												title: "危害",
												list: [
													"变压器效率低下，不利于节能；",
													"功率因数低导致多交力调电费。",
												],
											},
											{
												title: "建议",
												list: ["调节运行方式，合理规划用电负荷。"],
											},
										],
									};
								} else if (val <= 70) {
									return {
										title: "平均负载正常",
										color: "#68D86A",
										infos: [
											{
												title: "",
												list: [
													"用电负荷与变压器容量在合理范围内；",
													"变压器平均负载率：一定时间内，变压器平均输出的视在功率与变压器额定容量之比。",
												],
											},
										],
									};
								} else if (val <= 500) {
									return {
										title: "平均负载过高",
										color: "#FD4238",
										infos: [
											{
												title: "危害",
												list: [
													"变压器损耗加大、影响效率，不利于节能；",
													"变压器温度过高，加速变压器绝缘老化，减少使用寿命，严重时损坏变压器。",
												],
											},
											{
												title: "建议",
												list: ["调节运行方式，合理规划用电负荷。"],
											},
										],
									};
								} else {
									return {
										title: "暂无数据，无法分析",
										color: "#bbb",
										infos: [],
									};
								}
							},
						},
						{
							type: "4",
							otherInfo: [
								{
									title: "记录时间",
									value: () => {
										// return this.influxDataLoad != undefined && this.influxDataLoad
										//     .allmaxtime != undefined ?
										//     dateFormat(
										//         "YY-mm-dd HH:MM:SS",
										//         new Date(this.influxDataLoad.allmaxtime)
										//     ) :
										//     "--";
										return this.influxDataLoad != undefined &&
										this.influxDataLoad[this.loadfactor + "maxtime"] !=
										undefined
											? dateFormat(
												"YY-mm-dd HH:MM:SS",
												new Date(
													this.influxDataLoad[this.loadfactor + "maxtime"]
												)
											)
											: "--";
									},
									unit: "",
								},
							],
							details: [
								{
									title: "历史最大负载",
									value: "P",
									unit: "kVA",
									func: (that) => {
										// return this.influxDataLoad != undefined && this.influxDataLoad
										//     .allmax != undefined ?
										//     floatFormat(this.influxDataLoad.allmax / 1000, 2) :
										//     "--";
										that.title = this.loadTitle + "最大负载";
										return this.influxDataLoad != undefined &&
										this.influxDataLoad[this.loadfactor + "max"] != undefined
											? floatFormat(
												this.influxDataLoad[this.loadfactor + "max"] / 1000,
												2
											)
											: "--";
									},
								},
								{
									title: "历史最大负载率",
									value: "P",
									unit: "%",
									func: (that) => {
										that.title = this.loadTitle + "最大负载率";
										return this.influxDataLoad != undefined &&
										this.influxDataLoad[this.loadfactor + "max"] != undefined
											? floatFormat(
												this.influxDataLoad[this.loadfactor + "max"] /
												10 /
												this.capacity,
												2
											)
											: "--";
									},
								},
							],
						},
						{
							type: "4",
							otherInfo: [
								{
									title: "记录时间",
									value: () => {
										return this.influxDataLoad != undefined &&
										this.influxDataLoad.allmintime != undefined
											? dateFormat(
												"YY-mm-dd HH:MM:SS",
												new Date(this.influxDataLoad.allmintime)
											)
											: "--";
									},
									unit: "",
								},
							],
							details: [
								{
									title: "历史最小负载",
									unit: "kVA",
									value: "P",
									func: (that) => {
										that.title = this.loadTitle + "最小负载";
										return this.influxDataLoad != undefined &&
										this.influxDataLoad[this.loadfactor + "min"] != undefined
											? floatFormat(
												this.influxDataLoad[this.loadfactor + "min"] / 1000,
												2
											)
											: "--";
									},
								},
								{
									title: "历史最小负载率",
									unit: "%",
									value: "P",
									func: (that) => {
										// return this.influxDataLoad != undefined && this.influxDataLoad
										//     .allmin != undefined ?
										//     floatFormat(
										//         this.influxDataLoad.allmin / 10 / this.capacity,
										//         2
										//     ) :
										//     "--";
										that.title = this.loadTitle + "最小负载率";
										return this.influxDataLoad != undefined &&
										this.influxDataLoad[this.loadfactor + "min"] != undefined
											? floatFormat(
												this.influxDataLoad[this.loadfactor + "min"] /
												10 /
												this.capacity,
												2
											)
											: "--";
									},
								},
							],
						},
						{
							type: "4",
							otherInfo: [
								{
									title: "额定容量",
									value: () => {
										return this.capacity;
									},
									unit: " kVA",
								},
							],
							details: [
								{
									title: "历史平均负载",
									unit: "kVA",
									value: "P",
									func: (that) => {
										// return this.influxDataLoad != undefined && this.influxDataLoad
										//     .allmean != undefined ?
										//     floatFormat(this.influxDataLoad.allmean / 1000, 2) :
										//     "--";
										that.title = this.loadTitle + "平均负载";
										return this.influxDataLoad != undefined &&
										this.influxDataLoad[this.loadfactor + "mean"] != undefined
											? floatFormat(
												this.influxDataLoad[this.loadfactor + "mean"] / 1000,
												2
											)
											: "--";
									},
								},
								{
									title: "历史平均负载率",
									unit: "%",
									value: "P",
									func: (that) => {
										// return this.influxDataLoad != undefined && this.influxDataLoad
										//     .allmean != undefined ?
										//     floatFormat(
										//         this.influxDataLoad.allmean / 10 / this.capacity,
										//         2
										//     ) :
										//     "--";
										that.title = this.loadTitle + "平均负载率";
										return this.influxDataLoad != undefined &&
										this.influxDataLoad[this.loadfactor + "mean"] != undefined
											? floatFormat(
												this.influxDataLoad[this.loadfactor + "mean"] /
												10 /
												this.capacity,
												2
											)
											: "--";
									},
								},
							],
						},
					],
				],
				transformerTab: 0,
				isActive: false,
				allNodeData: [],
				selectAll: false,
				radio: "day",
				canvasShow: true,
				showMax: false,
				node: "0-0",
				date: new Date(),
				diagramSelected: 0,
				diagramData: null,
				diagramData1: null,
				points: {},
				treeData: [
					{
						id: "0",
						label: "功率因数",
						node: "PF",
						children: [
							{
								id: "0-1",
								label: "A相功率因数",
								node: "PFa",
							},
							{
								id: "0-2",
								label: "B相功率因数",
								node: "PFb",
							},
							{
								id: "0-3",
								label: "C相功率因数",
								node: "PFc",
							},
						],
					},
					{
						id: "1",
						label: "有功功率",
						node: "PA",
						unit: "kW",
						children: [
							{
								id: "1-1",
								label: "A相有功功率",
								node: "PAa",
								unit: "kW",
							},
							{
								id: "1-2",
								label: "B相有功功率",
								node: "PAb",
								unit: "kW",
							},
							{
								id: "1-3",
								label: "C相有功功率",
								node: "PAc",
								unit: "kW",
							},
						],
					},
					{
						id: "2",
						label: "无功功率",
						node: "PR",
						unit: "kVar",
						children: [
							{
								id: "2-1",
								label: "A相无功功率",
								node: "PRa",
								unit: "kVar",
							},
							{
								id: "2-2",
								label: "B相无功功率",
								node: "PRb",
								unit: "kVar",
							},
							{
								id: "2-3",
								label: "C相无功功率",
								node: "PRc",
								unit: "kVar",
							},
						],
					},
					{
						id: "3",
						label: "视在功率",
						node: "P",
						unit: "kVA",
						children: [
							{
								id: "3-1",
								label: "A相视在功率",
								node: "Pa",
								unit: "kVA",
							},
							{
								id: "3-2",
								label: "B相视在功率",
								node: "Pb",
								unit: "kVA",
							},
							{
								id: "3-3",
								label: "C相视在功率",
								node: "Pc",
								unit: "kVA",
							},
						],
					},
					{
						id: "4",
						label: "频率",
						node: "F",
						unit: "Hz",
					},
					{
						id: "5",
						label: "相电压",
						children: [
							{
								id: "5-1",
								label: "A相电压",
								node: "Ua",
								unit: "V",
							},
							{
								id: "5-2",
								label: "B相电压",
								node: "Ub",
								unit: "V",
							},
							{
								id: "5-3",
								label: "C相电压",
								node: "Uc",
								unit: "V",
							},
						],
					},
					{
						id: "6",
						label: "线电压",
						children: [
							{
								id: "6-1",
								label: "A相线电压",
								node: "Uab",
								unit: "V",
							},
							{
								id: "6-2",
								label: "B相线电压",
								node: "Ubc",
								unit: "V",
							},
							{
								id: "6-3",
								label: "C相线电压",
								node: "Uac",
								unit: "V",
							},
						],
					},
					{
						id: "7",
						label: "电流",
						children: [
							{
								id: "7-1",
								label: "A相电流",
								node: "Ia",
								unit: "A",
							},
							{
								id: "7-2",
								label: "B相电流",
								node: "Ib",
								unit: "A",
							},
							{
								id: "7-3",
								label: "C相电流",
								node: "Ic",
								unit: "A",
							},
						],
					},
				],

				influxData: {}, //平均负载
				influxDataLoad: {}, //最大负载
				listInfo: [
					{
						id: 0,
						name: "A相:",
						a: "/I1a",
					},
					{
						name: "B相:",
						a: "/I1b",
						id: 1,
					},
					{
						name: "C相:",
						a: "/I1c",
						id: 2,
					},
				],
			};
		},
		computed: {
			current() {
				let a;
				a = this.currentLoop.sensors.filter((item) => {
					item.p = item.sensorName;
					return item;
				});
				if (a.length % 2 != 0) {
					a.push({});
				}
				return a;
			},
			listStatus() {
				if (this.currentLoop.sensors) {
					let a = [];
					return this.currentLoop.sensors.filter((item) => {
						if (
							this.$store.getters.mqttVal(
								this.currentLoop.subLoopUrl + "/" + item.sensorNode
							) == 0
						) {
							return a.push(item);
						}
					});
				}
			},
			numStatus() {
				if (this.currentLoop.sensors) {
					let b = [];
					return this.currentLoop.sensors.filter((item) => {
						if (
							this.$store.getters.mqttVal(
								this.currentLoop.subLoopUrl + "/" + item.sensorNode
							) > 0
						) {
							return b.push(item);
						}
					});
				}
			},
			fow() {
				if (
					this.$store.getters.mqttVal(this.currentLoop.subLoopUrl + "/THD_Ua") >
					4 ||
					this.$store.getters.mqttVal(this.currentLoop.subLoopUrl + "/THD_Ub") >
					4 ||
					this.$store.getters.mqttVal(this.currentLoop.subLoopUrl + "/THD_Uc") > 4
				) {
					return 5;
				} else {
					return 1;
				}
			},
			//   单数
			singular() {
				var a = [];
				for (var i = 0; i < 23; i++) {
					if (i % 2 == 1) {
						// console.log(i);
						a.push(i);
						// console.log(a);
					}
				}
				return a;
			},
			capacity() {
				if (this.currentLoop)
					return this.$route.params.name == "Transformer"
						? parseInt(
							JSON.parse(this.currentLoop.device_details)["电气"]["容量"]
						)
						: 0;
			},
			// 组合k1 k2 变化时触发watch: k1k2
			k1k2() {
				return [this.k1, this.k2];
			},
			canvasData() {
				let strings = this.node.split("-");
				let data = this.realData[strings[0]].details[strings[1]].data;
				let loopId = this.currentLoop.loopId;
				let promises = [];
				let legendTitle = [];
				let defaultlegendTitle = [];
				for (let key in data) {
					if (data.hasOwnProperty(key)) {
						let node = data[key];
						if (node) {
							if (this.routeName == "PowerData") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else if (this.routeName == "Breaker") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else if (this.routeName == "protect1") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else if (this.routeName == "PowerQuality") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else {
								if (this.selectLabel == "三相温度") {
									legendTitle.push(key == "环境温度" ? key : key + "相温度");
								} else {
									legendTitle.push(key);
								}
							}
							defaultlegendTitle.push(key);
							console.log(this.currentLoop, node, this.date, data, legendTitle);
							if (node == "Temperature") {
								//    console.log(111)
								promises.push(
									LOOP_DIAGRAM_DATA_BY_DAY(
										this.currentLoop.sensorLoopId,
										node,
										this.date
									)
								);
							} else {
								// console.log(2222)
								promises.push(LOOP_DIAGRAM_DATA_BY_DAY(loopId, node, this.date));
							}
						}
					}
				}

				Promise.all(promises).then((res) => {
					let pointsArray = res.map((r) =>
						r.data.data.points ? r.data.data.points : []
					);
					let list = [];
					pointsArray.forEach((e) => {
						list = list.concat(e);
					});

					if (this.selectLabel === "负载率") {
						list.forEach(
							(p) => (p.val = floatFormat(p.val / 10 / this.capacity, 2))
						);
					} else {
						list.forEach((p) => (p.val = floatFormat(p.val, 2)));
					}

					let obj = {};
					let xAxisData = [];
					let seriesData = [];
					list.forEach((e, i) => {
						if (!obj[e.time]) {
							let val = dateFormat("HH", new Date(e.time));
							xAxisData.push(val < 10 ? val.substring(1, 2) + "点" : val + "点");
						}
						obj[e.time] = 1;
					});
					if (xAxisData[xAxisData.length - 1] == "0点") {
						xAxisData[xAxisData.length - 1] = "24点";
					}
					this.points = {};
					pointsArray.forEach((e, i) => {
						seriesData.push({
							name: legendTitle[i],
							data: e.map((p) => floatFormat(p.val, 2)),
						});

						this.$set(this.points, defaultlegendTitle[i], e);
					});
					this.$set(
						this,
						"diagramData",
						this.createCanvasData(legendTitle, xAxisData, seriesData)
					);
					this.$set(
						this,
						"diagramData1",
						this.createCanvasData1(legendTitle, xAxisData, seriesData)
					);
				});
				return true;
			},
			// 判断是否为报警项数据
			isAlarm() {
				return (node) => this.$store.getters.isAlarm(this.currentLoop, node);
			},
			// 组合tag和routeName 变化时触发watch: routeNameAndTag
			routeNameAndTag() {
				return [this.routeName, this.tag];
			},
			//路由名称
			routeName() {
				return this.$route.params.name;
			},
			//路由tag
			tag() {
				return this.$route.params.tag;
			},
			//是否全选
			isSelectedAll() {
				let nodes = [];
				this.getNodes(nodes, this.treeData);
				let newVar =
					nodes.length === this.selectedNodes.length && nodes.length !== 0;
				return (this.selectAll = newVar);
			},
			//选择的node
			selectedNodes() {
				let obj = {};
				let nodes = [];
				this.getNodes(nodes, this.allNodeData);
				return nodes.filter((n) => {
					if (obj[n]) {
						return false;
					}
					obj[n] = n;
					return true;
				});
			},
			//select选择的label
			selectLabel() {
				return this.options.filter((item) => item.value === this.node)[0].label;
			},
			val() {
				return (time, key) => {
					if (this.points[key]) {
						let filterElement = this.points[key].filter(
							(p) => new Date(p.time).getTime() === time.getTime()
						)[0];
						return filterElement ? filterElement : {};
					}
					return {};
				};
			},
			//table数据
			tableData() {
				return this.allTimes
					.map((time) => {
						let obj = {
							time: dateFormat("YYYY/mm/dd HH:MM:SS", time),
							name: this.currentLoop.loopName,
						};
						for (let key in this.tabTitle) {
							if (this.tabTitle.hasOwnProperty(key)) {
								if (key !== "name" && key !== "time") {
									let val = this.val(time, key).val;
									obj[key] = val ? Number(val).toFixed(2) : "--";
								}
							}
						}
						return obj;
					})
					.filter((e) => e);
			},
			allTimes() {
				let all = [];
				for (let k in this.points) {
					if (this.points.hasOwnProperty(k)) {
						all = all.concat(this.points[k]);
					}
				}
				let obj = {};
				all.forEach((p) => (obj[p.time] = 1));

				let res = [];
				for (let k in obj) {
					if (obj.hasOwnProperty(k)) {
						res.push(new Date(k));
					}
				}
				return res;
			},
			tabTitle(v) {
				let strings = this.node.split("-");
				let detail = this.realData[strings[0]].details[strings[1]];
				let data = detail.data;

				let newVar = {};

				this.$route.params.name == "Transformer"
					? (newVar = {
						name: "设备名称",
						time: "采集时间",
						A: "",
						B: "",
						C: "",
						总: "",
					})
					: (newVar = {
						name: "回路名称",
						time: "采集时间",
						A: "",
						B: "",
						C: "",
						总: "",
					});

				let i = 0;
				for (let k in data) {
					if (data.hasOwnProperty(k)) {
						if (data[k]) {
							// console.log(data[k], "我是NAme")
							if (data[k].includes("Temperature_")) {
								newVar[k.replace(/相*$/, "")] =
									k + "相" + (detail.unit ? `(${detail.unit})` : "");
							} else if (data[k] == "Temperature") {
								newVar[k] = k + (detail.unit ? `(${detail.unit})` : "");
							} else if (data[k].includes("H_U")) {
								let sp = data[k].split("_");
								// console.log(data[k], "我是data[k]", k)
								newVar[k.replace(/相*$/, "")] =
									k +
									"相电压" +
									`${sp[2]}` +
									"次谐波" +
									(detail.unit ? `(${detail.unit})` : "");
							} else if (data[k].includes("H_I")) {
								let sp = data[k].split("_");
								// console.log(sp[2])
								newVar[k.replace(/相*$/, "")] =
									k +
									"相电流" +
									`${sp[2]}` +
									"次谐波" +
									(detail.unit ? `(${detail.unit})` : "");
							} else {
								newVar[k.replace(/相*$/, "")] =
									dict(data[k]) + (detail.unit ? `(${detail.unit})` : "");
							}
						} else {
							newVar[k] = data[k];
						}
					}
				}
				return newVar;
			},
			min() {
				return (key) => {
					let data = this.diagramData.series.filter((e) => {
						return e.name === key;
					});
					if (data.length === 0) {
						return 0;
					}
					if (data[0].data.length === 0) {
						return "--";
					}
					let minValue = Math.min(...data[0].data);
					let minTimeIndex = data[0].data.findIndex((item) => item == minValue);
					let minTime = this.diagramData.xAxis.data[minTimeIndex];
					return (
						floatFormat(Math.min(...data[0].data), 2) +
						` (${this.formateTime(minTime)})`
					);
				};
			},
			average() {
				return (key) => {
					let data = this.diagramData.series.filter((e) => {
						return e.name === key;
					});
					if (data.length === 0) {
						return 0;
					}
					if (data[0].data.length === 0) {
						return "--";
					}
					let sum = 0;
					data[0].data.forEach((e) => (sum += +e));
					return floatFormat(sum / data[0].data.length, 2);
				};
			},
			max() {
				return (key) => {
					let data = this.diagramData.series.filter((e) => {
						return e.name === key;
					});
					if (data.length === 0) {
						return 0;
					}
					if (data[0].data.length === 0) {
						return "--";
					}
					let maxValue = Math.max(...data[0].data);
					let maxTimeIndex = data[0].data.findIndex((item) => item == maxValue);
					let maxTime = this.diagramData.xAxis.data[maxTimeIndex];
					return (
						floatFormat(Math.max(...data[0].data), 2) +
						` (${this.formateTime(maxTime)})`
					);
				};
			},

			mqttval() {
				return this.getMqttVal(this.$store.getters.mqttVal);
			},
			getMqttMaxVal() {
				return this.getMqttVal(this.$store.getters.mqttMaxVal);
			},
			getMqttMeanVal() {
				return this.getMqttVal(this.$store.getters.mqttMeanVal);
			},
			getMqttMinVal() {
				return this.getMqttVal(this.$store.getters.mqttMinVal);
			},
			nextDayDisabled() {
				let timestamp = dateFormat("YY-mm-dd", new Date());
				let endtime = dateFormat("YY-mm-dd", this.date);
				if (this.radio === "year") {
					timestamp = dateFormat("YY", new Date());
					endtime = dateFormat("YY", this.date);
				} else if (this.radio === "month") {
					timestamp = dateFormat("YY-mm", new Date());
					endtime = dateFormat("YY-mm", this.date);
				}
				// console.log(endtime,timestamp)
				if (endtime >= timestamp) {
					return true;
				} else {
					return false;
				}
			},
		},
		created() {
			let n = this.routeNameAndTag;
			if (n[0] === "PowerQuality" && n[1] === "none") {
				this.k1 = 0;
				this.k2 = 0;
				this.node = "2-0";
			} else {
				this.node = "1-2";
			}
		},
		async mounted() {
			let _this = this;
			window.onclick = () => {
				_this.isActive = false;
			};
			_this.influxdbDataInit();
			this.$route.params.name == "Transformer"
				? _this.influxdbDataLoadInit()
				: null;
			_this.initPowerTimeData();
			_this.canvasData;
			_this.nextDayDisabled;
			// _this.nextYearDisabled;
			setInterval(() => {
				let date = new Date().toLocaleTimeString().replace(/^\D*/, "");
				let time1 = date.split(":")[1];
				let time2 = date.split(":")[2];
				if ((time1 == "30" || time1 == "00") && time2 == "01") {
					_this.canvasDataRult();
				}
			}, 1000);
			if (this.routeName == "Running" || this.routeName == "Extremum") {
				this.currentChange(null, {
					checkedNodes: this.treeData[7].children,
				});
				this.$refs.tree.setCheckedNodes(this.treeData[7].children);
				this.selectedLoops = [];
			}
		},
		activated() {
			this.initPowerTimeData();
		},
		watch: {
			node() {
				//this.tableData = []
				this.tshow = false;
				this.$nextTick(() => {
					this.tshow = true;
				});
			},
			k1k2(n) {
				let k1 = n[0];
				let k2 = n[1];
				if (k1 === 0) {
					// 电压
					this.node = k2 * 2 + "-0";
				} else {
					this.node = k2 * 2 + 1 + "-0";
				}
			},
			tag(n, o) {
				this.initPowerTimeData();
			},
			routeName(n) {
				if (n !== "Running") {
					this.radio = "month";
				}

				let temp = this.routeNameAndTag;
				if (temp[0] === "PowerQuality" && temp[1] === "none") {
					this.node = "2-0";
				} else {
					this.node = "1-2";
				}
			},
			selectAll(n) {
				if (n) {
					this.$refs.tree.setCheckedNodes(this.treeData);
					this.allNodeData = this.$refs.tree
						.getCheckedNodes()
						.filter((e) => e.node);
				}
			},
			diagramSelected() {
				this.reload();
			},
			radio(n) {
				this.date = new Date();
			},
			showMax(n, o) {
				this.canvasDataRult();
				this.reload();
			},
			selectedLoops(n, o) {
				this.influxdbDataInit();
				this.$route.params.name == "Transformer"
					? this.influxdbDataLoadInit()
					: null;
			},
		},
		methods: {
			handleCommand(command) {
				this.loadfactor = command;
				if (command == "year") {
					this.loadTitle = "本年";
				} else if (command == "month") {
					this.loadTitle = "本月";
				} else {
					this.loadTitle = "今日";
				}
			},
			formateIntercept(item) {
				if (item.indexOf("A") > -1) {
					return "A";
				} else if (item.indexOf("B") > -1) {
					return "B";
				} else if (item.indexOf("C") > -1) {
					return "C";
				} else if (item.indexOf("总") > -1) {
					return "总";
				} else {
					return item;
				}
			},
			formateTime(string) {
				let array = string.split("");
				array.pop();
				if (array.length < 2) {
					return "0" + array[0] + ":00";
				} else {
					return array.join("") + ":00";
				}
			},
			async getSensorLoopID(areaId) {
				let sensorLoopId = -1;
				await GetSensor(areaId).then((res) => {
					if (res.data.data.loop) {
						sensorLoopId = res.data.data.loop.loopId;
					}
				});
				return sensorLoopId;
			},
			async influxdbDataInit() {
				let self = this;
				let obj = {
					deviceLoopIdList: [self.currentLoop.loopId],
					start: dayStart(new Date()),
					end: dayEnd(new Date()),
					group: "8h",
					nodes: ["P"],
					// projectId:3,
				};
				let response = await INFLUX_QUERY(
					obj.deviceLoopIdList,
					obj.start,
					obj.end,
					obj.group,
					obj.nodes
				);
				let data = response.data.data.influxData.results[0].series || [];
				// self.influxData = data[0].values[0]
				// console.log(self.influxData)
				data.forEach((item) => {
					if (item.tags.node == "P") {
						for (
							var i = item.values.length - 1;
							-1 < i < item.values.length - 1;
							i--
						) {
							if (item.values[i][2] != null) {
								self.influxData = item.values[i];
								// console.log(self.influxData)
								return;
							}
						}
					}
				});
			},

			async influxdbDataLoadInit() {
				let self = this;
				let obj = {
					deviceLoopIdList: [self.currentLoop.loopId],
					start: dayStart(new Date()),
					end: dayEnd(new Date()),
					group: "1d",
					nodes: ["Ia", "Ib", "Ic"],
				};
				let response = await influx_load(
					obj.deviceLoopIdList,
					obj.start,
					obj.end,
					obj.group
				);
				// let data = response.data.data.influxData.results[0].series || [];
				// var maxLoad = 0;
				// try{
				// 	for(var i = data[0].values.length-1; i >= 0 ;i--){
				// 	for(var j = 0;j < data.length;j++){
				// 		if(data[j].values[i][2] != null && data[j].values[i][2] != 0 && data[j].values[i][2] != undefined){
				// 			maxLoad = Math.max(maxLoad,data[j].values[i][2]);
				// 			if(j == 2){
				// 				var map = new Map();
				// 				map.set("maxLoad",maxLoad);
				// 				map.set("maxLoadPer",maxLoad/909.4*100);
				// 				console.log(map)
				// 				// self.influxDataLoad = map
				// 				self.influxDataLoad = {
				// 					maxLoad:maxLoad,
				// 					maxLoadPer:maxLoad/909.4*100
				// 				}
				// 				throw new Error(100)
				// 			}
				// 		}else{
				// 			maxLoad = 0;
				// 			break;
				// 		}
				// 	}
				// }
				// } catch(e){}

				self.influxDataLoad = response.data.data.influxData;
			},
			async influxdbDataLoadInit() {
				let response = await influx_workload(this.currentLoop.loopId);
				this.influxDataLoad = response.data.data.influxData.data.res;
			},
			canvasDataRult() {
				let strings = this.node.split("-");
				let data = this.realData[strings[0]].details[strings[1]].data;
				let loopId = this.currentLoop.loopId;
				let promises = [];
				let legendTitle = [];
				let defaultlegendTitle = [];
				for (let key in data) {
					if (data.hasOwnProperty(key)) {
						let node = data[key];
						if (node) {
							// legendTitle.push(
							//     key === "总" ? key : (key + "相").replace(/相*$/, "")
							// );
							if (this.routeName == "PowerData") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else if (this.routeName == "Breaker") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else if (this.routeName == "protect1") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else if (this.routeName == "PowerQuality") {
								if (this.selectLabel == "三相电流") {
									legendTitle.push(key + "相电流");
								} else if (this.selectLabel == "三相电压") {
									legendTitle.push(key + "相电压");
								} else if (this.selectLabel == "三相线电压") {
									legendTitle.push(key + "相线电压");
								} else {
									legendTitle.push(
										key === "总"
											? key + this.selectLabel
											: key + "相" + this.selectLabel
									);
								}
							} else {
								if (this.selectLabel == "三相温度") {
									legendTitle.push(key == "环境温度" ? key : key + "相温度");
								} else {
									legendTitle.push(key);
								}
							}
							defaultlegendTitle.push(key);
							if (node == "Temperature") {
								promises.push(
									LOOP_DIAGRAM_DATA_BY_DAY(
										this.currentLoop.sensorLoopId,
										node,
										this.date
									)
								);
							} else {
								promises.push(LOOP_DIAGRAM_DATA_BY_DAY(loopId, node, this.date));
							}
						}
					}
				}

				Promise.all(promises).then((res) => {
					let pointsArray = res.map((r) => (r.data ? r.data.data.points : []));
					let list = [];
					pointsArray.forEach((e) => {
						list = list.concat(e);
					});

					if (this.selectLabel === "负载率") {
						list.forEach(
							(p) => (p.val = floatFormat(p.val / 10 / this.capacity, 2))
						);
					} else {
						list.forEach((p) => (p.val = floatFormat(p.val, 2)));
					}

					let obj = {};
					let xAxisData = [];
					let seriesData = [];

					list.forEach((e) => {
						if (!obj[e.time]) {
							let val = dateFormat("HH", new Date(e.time));
							xAxisData.push(val < 10 ? val.substring(1, 2) + "点" : val + "点");
						}
						obj[e.time] = 1;
					});

					this.points = {};
					pointsArray.forEach((e, i) => {
						seriesData.push({
							name: legendTitle[i],
							data: e.map((p) => floatFormat(p.val, 2)),
						});

						this.$set(this.points, defaultlegendTitle[i], e);
					});
					this.$set(
						this,
						"diagramData",
						this.createCanvasData(legendTitle, xAxisData, seriesData)
					);

					this.$set(
						this,
						"diagramData1",
						this.createCanvasData1(legendTitle, xAxisData, seriesData)
					);
				});
				return true;
			},
			getLoopStatus(tpl) {
				// console.log(this.$store.getters.mqttVal(tpl.subLoopUrl + '/SwitchOn'), tpl.subLoopUrl)
				return this.$store.getters.mqttVal(tpl.subLoopUrl + "/SwitchOn");
			},

			getLoopLTStatus(tpl) {
				return this.$store.getters.mqttVal(tpl.switchStatus);
			},
			getBreakerStatus(tpl) {
				return this.$store.getters.mqttVal(tpl.subLoopUrl + "/Switch_on_MT");
			},
			getBreakerLTStatus(tpl) {
				// console.log(this.$store.getters.mqttVal(tpl.switchStatus))
				return this.$store.getters.mqttVal(tpl.switchStatus);
			},
			getMqttVal(f) {
				return (k, m) => {
					if (this.currentLoop && k) {
						// console.log(this.currentLoop.subLoopUrl +'/' + k)
						k = this.currentLoop.subLoopUrl + "/" + k;
						// k = 'T2/Transformer/' + k;
						let mqttVal = f(k);
						if (m) {
							mqttVal *= m;
							// mqttVal = floatFormat(mqttVal, 1);
						}

						mqttVal = floatFormat(mqttVal, 2);

						// console.log(typeof mqttVal)

						if (typeof mqttVal === "object") {
							return mqttVal;
						}

						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
			exportFunc() {
				if (!this.diagramData.xAxis.data.length) {
					this.$message.warning("无图表数据！");
					return;
				}
				if (this.diagramSelected === 0) {
					this.$store.commit("exportDiagram", {
						type: "echarts",
						version: Math.random(),
					});
				} else {
					let data = [];
					this.$route.params.name == "Transformer"
						? (data = [["设备名称", "采集时间"]])
						: (data = [["回路名称", "采集时间"]]);
					let map = ["name", "time"];
					for (let k in this.tabTitle) {
						if (this.tabTitle.hasOwnProperty(k)) {
							let v = this.tabTitle[k];
							if (v && v !== "回路名称" && v !== "设备名称" && v !== "采集时间") {
								data[0].push(v);
								map.push(k);
							}
						}
					}

					this.tableData.forEach((d) => {
						data.push(map.map((k) => d[k]));
					});

					let name = "";
					if (this.routeName === "PowerData" && this.tag === "none") {
						name = "回路监测";
					} else if (this.routeName === "Transformer" && this.tag === "none") {
						name = "变压器监测";
					} else if (this.routeName === "Breaker" && this.tag === "none") {
						name = "断路器监测";
					} else if (this.routeName === "PowerQuality" && this.tag === "none") {
						name = "谐波分析";
					}
					exportExcel(data, name, []);
				}
			},
			isActiveClass(index, key) {
				return this.node === index + "-" + key;
			},
			initPowerTimeData() {
				if (
					(this.routeName === "Extremum" && this.tag === "PowerTime") ||
					this.tag === "Range"
				) {
					this.allNodeData = [
						{
							id: "0-1",
							label: "用电量",
							node: "PA_total",
						},
					];
					this.radio = "month";
				} else {
					this.allNodeData = [];
				}
			},
			getNodes(nodes, list) {
				list.forEach((e) => {
					let node = e.node;
					if (node) {
						nodes.push(node);
					}
					if (e.children) {
						this.getNodes(nodes, e.children);
					}
				});
			},
			clearTreeData() {
				this.selectAll = false;
				this.$refs.tree.setCheckedNodes([]);
				this.allNodeData = [];
			},
			currentChange(data, nodes) {
				this.allNodeData = nodes.checkedNodes.filter((e) => e.node);
			},
			reload() {
				this.canvasShow = !this.canvasShow;
				this.$nextTick(() => {
					this.canvasShow = !this.canvasShow;
				});
			},
			perD() {
				this.date = perDay(this.date);
				// this.nextDayDisabled(this.date);
			},
			nextD() {
				this.date = nextDay(this.date);
				// console.log(this.date)
				// this.nextDayDisabled(this.date);
			},
			perM() {
				this.date = perMonth(this.date);
			},
			nextM() {
				this.date = nextMonth(this.date);
			},
			perY() {
				this.date = perYear(this.date);
			},
			nextY() {
				this.date = nextYear(this.date);
			},

			createCanvasData(legendData, xAxisData, seriesData) {
				this.canvasShow = false;
				// console.log(legendData, xAxisData, seriesData)
				// let mqttMaxVal = String(this.capacity*1000);
				// let re=/(?=(?!(\b))(\d{3})+$)/g;
				let mqttMaxVal, re;
				let yAxis = {
					nameTextStyle: {
						color: "#999999",
						fontSize: "14",
					},
					boundaryGap: true,
					axisTick: {
						//y轴刻度线
						show: false,
					},
					show: true,
					spiltLine: {
						show: true,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#CCCCCC",
							width: 1,
							type: "solid",
						},
					},
					axisLabel: {
						//x轴文字的配置
						show: true,
						textStyle: {
							color: "#999999",
						},
					},
					type: "value",
				};
				let markPoint = {};
				if (this.showMax) {
					//最值分析加标点
					markPoint = {
						data: [
							{
								type: "max",
								name: "最大值",
							},
							{
								type: "min",
								name: "最小值",
							},
						],

						symbol: "pin",
						symbolSize: "20",
						// symbolOffset:[0,0],
						label: {
							position: "top",
							// show:false
						},
					};
				}
				let series;
				if (this.selectLabel == "三相温度") {
					let markLine = {
						//添加警戒线
						symbol: "none",
						label: {
							position: "insideEndTop",
							formatter: (a) => {
								if (a.value == 85) {
									return "预警温度:" + 85 + "℃";
								} else if (a.value == 95) {
									return "报警温度:" + 95 + "℃";
								}
							},
						},
						data: [
							{
								yAxis: 85,
								name: "预警温度",
								lineStyle: {
									color: "#F5AA00",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#F5AA00",
								},
							},
							{
								yAxis: 95,
								name: "报警温度",
								lineStyle: {
									color: "#FD4238",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#FD4238",
								},
							},
						],
					};
					series = seriesData.map((e) => {
						return e.name == "环境温度"
							? {
								smooth: true,
								name: e.name,
								type: "line",
								lineStyle: {
									type: "dotted",
								},
								areaStyle: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
										{
											offset: 0,
											color: "rgb(93 112 146 / 25%)",
										},
										{
											offset: 1,
											color: "#5d709200",
										},
									]),
								},
								data: e.data,
								connectNulls: true,
								markPoint,
								markLine,
							}
							: {
								smooth: true,
								name: e.name,
								type: "line",
								data: e.data,
								connectNulls: true,
								markPoint,
								markLine,
							};
					});
					yAxis.max = 100;
				} else if (this.selectLabel == "负载监测") {
					mqttMaxVal = String(this.capacity * 1000);
					re = /(?=(?!(\b))(\d{3})+$)/g;
					let markLine = {
						//添加警戒线
						symbol: "none",
						label: {
							position: "insideEndTop",
							formatter: (a) => {
								if (a.value == mqttMaxVal * 1.1) {
									return "超载标准:" + String(mqttMaxVal * 1.1).replace(re, ",");
								} else if (a.value == mqttMaxVal * 1) {
									return "满载标准:" + String(mqttMaxVal * 1).replace(re, ",");
								} else {
									return "重载标准:" + String(mqttMaxVal * 0.8).replace(re, ",");
								}
							},
						},
						data: [
							{
								yAxis: mqttMaxVal * 1.1,
								name: "超载标准",
								lineStyle: {
									color: "#FD4238",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#FD4238",
								},
							},
							{
								yAxis: mqttMaxVal * 1,
								name: "满载标准",
								lineStyle: {
									color: "#F5AA00",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#F5AA00",
								},
							},
							{
								yAxis: mqttMaxVal * 0.8,
								name: "重载标准",
								lineStyle: {
									color: "#68D86A",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#68D86A",
								},
							},
						],
					};
					series = seriesData.map((e) => {
						return {
							smooth: true,
							name: e.name,
							type: "line",
							data: e.data,
							connectNulls: true,
							markPoint,
							markLine,
						};
					});
					yAxis.name = "视在功率(VA)";
					yAxis.max = mqttMaxVal * 1.1;
				} else {
					series = seriesData.map((e) => {
						return {
							smooth: true,
							name: e.name,
							type: "line",
							data: e.data,
							connectNulls: true,
							markPoint,
						};
					});
				}
				let color = ["#F6BD16", "#5AD8A6", "#E8684A", "#5D7092"];
				if (this.selectLabel == "三相温度") {
					color = ["#F6BD16", "#5AD8A6", "#E8684A", "#5D7092"];
				}

				this.canvasShow = true;
				return {
					color,
					tooltip: {
						trigger: "axis",
					},
					legend: {
						top: 0,
						itemWidth: 10,
						itemHeight: 10,
						icon: "rect",
						data: legendData,
						textStyle: {
							fontSize: "16rem",
						},
						itemGap: 20,
						itemStyle: {},
					},
					grid: {
						left: 80,
						right: 80,
						bottom: "7%",
						//containLabel: true
					},
					toolbox: {
						feature: {
							//saveAsImage: {}
						},
					},
					xAxis: {
						type: "category",
						boundaryGap: false,
						data: xAxisData,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#CCCCCC",
								width: 1,
								type: "solid",
							},
						},
						axisLabel: {
							//x轴文字的配置
							show: true,
							textStyle: {
								color: "#999999",
							},
						},
					},
					// yAxis:{
					// 	type:"value"
					// },
					yAxis,
					series,
				};
			},

			createCanvasData1(legendData, xAxisData, seriesData) {
				this.canvasShow = false;
				let mqttMaxVal, re;
				let yAxis = {
					nameTextStyle: {
						color: "#999999",
						fontSize: "14",
					},
					boundaryGap: true,
					axisTick: {
						//y轴刻度线
						show: false,
					},
					show: true,
					spiltLine: {
						show: true,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#CCCCCC",
							width: 1,
							type: "solid",
						},
					},
					axisLabel: {
						//x轴文字的配置
						show: true,
						textStyle: {
							color: "#999999",
						},
					},
					type: "value",
				};
				let markPoint = {};
				if (this.showMax) {
					//最值分析加标点
					markPoint = {
						data: [
							{
								type: "max",
								name: "最大值",
							},
							{
								type: "min",
								name: "最小值",
							},
						],

						symbol: "pin",
						symbolSize: "20",
						// symbolOffset:[0,0],
						label: {
							position: "top",
							// show:false
						},
					};
				}
				let series;

				let seriesnew = [];
				seriesData.forEach((item, index) => {
					let data1 = [],
						data2 = [],
						data1new = [],
						data2new = [];
					if (item.data.length > 0) {
						for (var i = 0; i < item.data.length; i++) {
							if (item.data[i] == item.data[i + 1]) {
								data1.push(null);
								data2.push(item.data[i]);
							} else {
								data1.push(item.data[i]);
								data2.push(null);
							}
						}

						data1new = JSON.parse(JSON.stringify(data1));
						for (var i = 0; i < data1.length; i++) {
							if (
								data1[i] != null &&
								data1[i + 1] == null &&
								data1[i + 1] < data1.length
							) {
								data1new[i + 1] = data2[i + 1];
							}
						}
						seriesnew.push({
							smooth: true,
							name: item.name,
							type: "line",
							data: data1new,
							lineStyle: {},
							itemStyle: {},
							markPoint,
						});
						data2new = JSON.parse(JSON.stringify(data2));
						for (var i = 0; i < data2.length; i++) {
							if (data2[i] != null && data2[i + 1] == null) {
								data2new[i + 1] = data2[i];
							}
						}
						seriesnew.push({
							smooth: true,
							name: item.name,
							type: "line",
							data: data2new,
							lineStyle: {
								normal: {
									// type:'dashed',
									width: 1,
									type: [3, 5],
									color: "#cccccc",
								},
							},
							itemStyle: {
								color: "#cccccc",
							},
							markPoint: {},
						});
					}

					// console.log(data1, data2)
					// console.log(data1new, data2new, 'new')
				});
				if (this.selectLabel == "三相温度") {
					let markLine = {
						//添加警戒线
						symbol: "none",
						label: {
							position: "insideEndTop",
							formatter: (a) => {
								if (a.value == 85) {
									return "预警温度:" + 85 + "℃";
								} else if (a.value == 95) {
									return "报警温度:" + 95 + "℃";
								}
							},
						},
						data: [
							{
								yAxis: 85,
								name: "预警温度",
								lineStyle: {
									color: "#F5AA00",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#F5AA00",
								},
							},
							{
								yAxis: 95,
								name: "报警温度",
								lineStyle: {
									color: "#FD4238",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#FD4238",
								},
							},
						],
					};
					seriesnew = seriesnew.map((e) => {
						return e.name == "环境温度"
							? {
								smooth: true,
								name: e.name,
								type: "line",
								lineStyle: {
									type: "dotted",
								},
								areaStyle: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
										{
											offset: 0,
											color: "#90e987b3",
										},
										{
											offset: 1,
											color: "#90e98703",
										},
									]),
								},
								data: e.data,
								markPoint,
								markLine,
							}
							: {
								smooth: true,
								name: e.name,
								type: "line",
								data: e.data,
								lineStyle: e.lineStyle,
								itemStyle: e.itemStyle,
								markPoint: e.markPoint,
								markLine,
							};
					});
					yAxis.max = 100;
				} else if (this.selectLabel == "负载监测") {
					mqttMaxVal = String(this.capacity * 1000);
					re = /(?=(?!(\b))(\d{3})+$)/g;
					let markLine = {
						//添加警戒线
						symbol: "none",
						label: {
							position: "insideEndTop",
							formatter: (a) => {
								if (a.value == mqttMaxVal * 1.1) {
									return "超载标准:" + String(mqttMaxVal * 1.1).replace(re, ",");
								} else if (a.value == mqttMaxVal * 1) {
									return "满载标准:" + String(mqttMaxVal * 1).replace(re, ",");
								} else {
									return "重载标准:" + String(mqttMaxVal * 0.8).replace(re, ",");
								}
							},
						},
						data: [
							{
								yAxis: mqttMaxVal * 1.1,
								name: "超载标准",
								lineStyle: {
									color: "#FD4238",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#FD4238",
								},
							},
							{
								yAxis: mqttMaxVal * 1,
								name: "满载标准",
								lineStyle: {
									color: "#F5AA00",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#F5AA00",
								},
							},
							{
								yAxis: mqttMaxVal * 0.8,
								name: "重载标准",
								lineStyle: {
									color: "#68D86A",
								},
								label: {
									position: "insideEndTop",
									fontSize: "12",
									color: "#68D86A",
								},
							},
						],
					};
					seriesnew = seriesnew.map((e) => {
						return {
							smooth: true,
							name: e.name,
							type: "line",
							data: e.data,
							lineStyle: e.lineStyle,
							itemStyle: e.itemStyle,
							markPoint: e.markPoint,
							markLine,
						};
					});
					yAxis.name = "视在功率(VA)";
					yAxis.max = mqttMaxVal * 1.2;
				} else {
					seriesnew = seriesnew.map((e) => {
						return {
							smooth: true,
							name: e.name,
							type: "line",
							data: e.data,
							lineStyle: e.lineStyle,
							itemStyle: e.itemStyle,
							markPoint: e.markPoint,
						};
					});
				}
				let color = ["#5B8FF9", "#5AD8A6", "#5D7092", "#F6BD16"];
				if (this.selectLabel == "三相温度") {
					color = ["#5B8FF9", "#5D7092", "#F6BD16", "#90e987"];
				}

				this.canvasShow = true;
				return {
					color,
					tooltip: {
						trigger: "axis",
						formatter: function (params) {
							var htmlStr = "";
							params = params
								.filter((e) => e.value != undefined)
								.reduce((cur, next) => {
									params[next.seriesName]
										? ""
										: (params[next.seriesName] = true && cur.push(next));
									return cur;
								}, []);
							htmlStr += params[0].name + "<br/>"; //x轴的名称
							for (var x = 0; x < params.length; x++) {
								if (params[x].value != undefined) {
									var color = params[x].color; //图例颜色
									htmlStr += "<div>";
									htmlStr +=
										'<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' +
										color +
										';"></span>';
									htmlStr += "<span >";
									htmlStr += params[x].seriesName + "：" + params[x].value;
									htmlStr += "</span>";
									htmlStr += "</div>";
								}
							}
							return htmlStr;
						},
					},
					legend: {
						top: 0,
						itemWidth: 10,
						itemHeight: 10,
						icon: "rect",
						data: legendData,
						textStyle: {
							fontSize: "16rem",
						},
						itemGap: 20,
						itemStyle: {},
					},
					grid: {
						left: 80,
						right: 80,
						bottom: "7%",
						//containLabel: true
					},
					toolbox: {
						feature: {
							//saveAsImage: {}
						},
					},
					xAxis: {
						type: "category",
						boundaryGap: false,
						data: xAxisData,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#CCCCCC",
								width: 1,
								type: "solid",
							},
						},
						axisLabel: {
							//x轴文字的配置
							show: true,
							textStyle: {
								color: "#999999",
							},
						},
					},
					// yAxis:{
					// 	type:"value"
					// },
					yAxis,
					series: seriesnew,
					// series,
				};
			},
		},
	};
</script>

<style scoped lang="less">
	.loadfactor {
		width: 120rem;
		text-align: center;
	}

	.el-dropdown-menu__item.active {
		color: #0d94ff;
	}

	.alarming {
		// color: #fd4238 !important;
	}

	.breaker-data-1 {
		.h(968) !important;
	}

	.tab-breaker {
		> div {
			font-size: 18rem;
			font-weight: 400;
			color: #999999;
			border-top: 2px solid #ffffff;
			padding-top: 23rem;
			margin-right: 25rem;

			&.active {
				font-weight: bold;
				color: #0d94ff;
				border-top: 2px solid rgba(13, 148, 255, 1);
			}
		}
	}

	.transformerClass {
		.h(570) !important;

		.echarts {
			.left {
				.h(400) !important;
			}
		}

		.max-right {
			.h(400) !important;
		}
	}

	.transformer-data {
		padding: 0 24rem;
		background-color: #fff;
		.h(389);

		.card-list {
			.card-item {
				.w(298);
				.h(254);
				padding: 0rem 24rem;
				border-radius: 4px;
				background-color: rgba(0, 43, 102, 0.04);
				position: relative;

				h5 {
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}

				span {
					font-size: 24rem;
					font-weight: bold;
					color: #0d94ff;
					// margin-top: 8rem;
				}

				.val-details {
					width: 100%;
					justify-content: space-between;
					// margin-top: 20rem;

					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999 !important;
					}
				}
			}

			.type-2 {
				// padding-top: 70rem;
				span {
					margin-top: 25rem;
				}
			}

			.type-3 {
				align-items: flex-start;
				padding: 0 20rem;

				h4 {
					font-size: 24px;
					font-weight: bold;
					color: #f5aa00;
				}

				h5.sub-title {
					font-size: 17rem;
					color: rgba(51, 51, 51, 1);
					font-weight: bold;
				}

				p {
					font-size: 14rem;
					color: rgba(153, 153, 153, 1);
				}

				h5,
				p {
					line-height: 32rem;
				}
			}

			.type-4 {
				// padding-bottom: 12px;

				.other {
					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999;
					}
				}
			}

			.type-1 .column-center,
			.type-4 .column-center {
				height: 90rem;
				// width: 100%;
			}

			.type-1 .column-center:first-child,
			.type-4 .column-center:first-child {
				// height: 135rem;
				// padding-top: 20rem;
				// justify-content: initial;
				// width: 100%;
			}

			.other {
				position: absolute;
				bottom: 12rem;
			}
		}

		.tab {
			span {
				display: inline-block;

				min-width: 88rem;
				line-height: 64rem;
				border-top: 2px solid #ffffff;
				font-size: 18rem;
				text-align: center;
				margin-right: 29rem;
				transition: all 0.3s;
				font-weight: 400;
				color: #999999;

				&.active {
					border-top: 2px solid rgba(13, 148, 255, 1);
					color: #0d94ff;
					font-weight: bold;
				}
			}
		}
	}

	.tree {
		width: 100%;
		background-color: #fff;
		transition: all 0.5s;
		overflow: hidden;
		box-shadow: 0 0 2px 0 #8c939d;

		.data {
			width: 100%;
			margin-top: 8rem;
			height: 100%;
		}

		.option {
			width: 100%;
			.h(40);
			border-bottom: 1px solid rgba(0, 0, 0, 0.06);
			padding: 0 16rem;
			font-size: 14rem;
			font-weight: 300;
			color: #333333;
			line-height: 36rem;

			.all {
				cursor: pointer;

				img {
					// width: 16rem;
					// height: 16rem;
					margin-right: 8rem;
				}

				span {
					&:hover {
						color: rgba(13, 148, 255, 1);
					}
				}
			}

			> span {
				cursor: pointer;
				color: rgba(13, 148, 255, 1);
			}
		}
	}

	.nodes-tree {
		.w(260);
		height: 40px;
		margin-right: 8rem;
		background-color: #ffffff;
	}

	.report {
		margin-top: 24rem;
		.h(815);
	}

	.export {
		margin-left: 23rem;

		img {
			margin-right: 7rem;
		}

		span {
			font-size: 18rem;
			font-weight: 500;
			color: #333333;
		}
	}

	.btn {
		.w(96);
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 18px;
		font-weight: 400;
		color: #ffffff;
		background-color: #0d94ff;
		cursor: pointer;
		border-radius: 4rem;
		overflow: hidden;
		padding: 0px;
	}

	.per,
	.next {
		background-color: #fff;
		font-size: 18rem;
		color: #666666;
		font-weight: 400;
		border: 1px solid rgba(0, 0, 0, 0.15);

		&:hover {
			background-color: #0d94ff;
			color: #ffffff;
		}
	}

	.el-button.is-plain:hover {
		background-color: #0d94ff !important;
		color: #ffffff !important;
		transition: 0s;
	}

	.el-button.is-active,
	.el-button.is-plain:active,
	.el-button.is-plain:focus {
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: #666666;
	}

	.el-button.is-disabled:hover {
		background-color: #ffffff !important;
		color: #c0c4cc !important;
		transition: 0s;
	}

	.per {
		// margin-left: 24rem;
	}

	.next {
		margin-left: 8rem;
	}

	.node-select,
	.dateSelect {
		.w(260) !important;
		// .h(40) !important;
	}

	.node-select {
		margin-right: 24rem;
	}

	.data-table {
		padding: 24rem;
		background-color: #fff;
		.w(1265);
		.h(968);

		.menu {
			margin-top: 24rem;

			.export {
				margin-left: 61rem;
			}

			.radio {
				margin-left: 24rem;

				.el-radio {
					margin-right: 20rem;
				}
			}
		}

		.title {
			font-size: 18rem;
			font-weight: bold;
			color: #333333;
		}
	}

	.diagram {
		.w(1265);
		.h(618);
		margin-top: 8rem;
		background-color: #fff;
		padding-left: 24rem;

		// display: flex;
		.exetext {
			.w(728);
			display: flex;
			align-items: center;
			justify-content: space-between;

			.exetext1 {
				display: flex;
				align-items: center;
			}
		}

		.left {
			width: 100%;
			.h(480);
		}

		.echarts {
			width: 100%;

			.left {
				width: 100%;
				.h(460);
			}

			.max-right {
				.w(272);
				// height: 380px;
				.h(460);
				margin-right: 24rem;

				.row-max {
					width: 100%;
					background-color: rgba(0, 43, 102, 0.02);
					// height: 88px;
					margin-bottom: 10px;

					.details {
						.w(176);
						height: 100%;
						padding: 12rem 0;

						span {
							margin-right: 8rem;
							color: rgba(13, 148, 255, 1);
							font-size: 16rem;

							&:first-child {
								color: #333333;
							}
						}
					}

					.max-name {
						height: 100%;
						.w(96);
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}
				}
			}
		}

		.showMax {
			div.left {
				.w(920) !important;
			}
		}

		.tab {
			width: 100%;
			.h(438);
			margin-top: 25rem;
		}

		.content {
			margin-top: 10rem;

			.dateSelect {
				font-size: 18rem;
				color: #000000 !important;
				margin-right: 8rem;
			}

			.max {
				.w(100);
				margin-left: 127rem;
			}

			.hose {
				display: flex;
				align-items: center;
			}
		}

		.select1 {
			margin-right: 27rem;
			font-size: 18rem;
			font-weight: 400;
			color: #333333;
			padding-top: 23rem;
			border-top: 2rem solid rgba(0, 0, 0, 0);
		}

		.select {
			> div {
				cursor: pointer;
				margin-right: 27rem;
				font-size: 18rem;
				font-weight: 400;
				color: #999999;
				padding-top: 21rem;
				border-top: 2rem solid rgba(0, 0, 0, 0);

				&.active {
					color: #0d94ff;
					font-weight: bold;
					border-top: 2rem solid #0d94ff;
				}
			}
		}
	}

	.real-data1 {
		.realLeft {
			padding: 24rem;
			.w(524);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);

			.status {
				width: 100%;
				.h(220);
				margin-top: 57rem;
				background-color: #fff;
				display: flex;
				justify-content: space-between;
			}

			.operation {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					.w(71);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus {
						font-size: 38rem;
						font-weight: bold;
						color: #68d86a;
					}

					.boxStatusOred {
						font-size: 38rem;
						font-weight: bold;
						color: #fd4238;
					}

					.boxStatusOBack {
						font-size: 38rem;
						font-weight: bold;
						color: #0d94ff;
					}
				}
			}

			.operation1 {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					.w(89);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus1 {
						// margin: auto;
						font-size: 18rem;

						.ax {
							width: 90%;
							margin: auto;
							display: flex;
							line-height: 28px;
							// justify-content: space-between;
							align-items: center;
							white-space: nowrap;
							font-size: 18rem;

							// p {
							//     font-size: 18rem;
							//     color: #333333;
							//     // white-space: nowrap
							// }

							.ax-2 {
								// display: flex;
								// justify-content: space-between;
								font-weight: 400;
								color: #0d94ff;
								font-size: 18rem;
								margin-right: 5rem;
							}
						}
					}
				}
			}
		}

		.realRight {
			.w(724);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
			padding: 24rem;

			.foune-1 {
				display: flex;
				justify-content: space-between;

				// background-color: red;
				.tit-1 {
					display: flex;
					.w(170);
					justify-content: space-between;
					.h(69);
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}
			}

			// .foune-2::-webkit-scrollbar {
			// width: 1px !important;
			// }
			.foune-2 {
				width: 100%;
				height: 80%;
				overflow-y: scroll;

				.oLi {
					width: 50%;
					height: 11%;
					background-color: #fff;
					// display: flex;
					border-top: rgba(0, 0, 0, 0.06) 1px solid;
					// align-items: center;
					float: left;

					.oli-Div {
						width: 100%;
						height: 100%;
						font-size: 18rem;
						display: flex;
						justify-content: space-between;
						padding-right: 35%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;
		}
	}

	.real-data {
		background-color: #ffffff;
		padding: 24rem;
		.h(342);

		.total-data {
			margin-top: 23rem;
			background: rgba(0, 43, 102, 0.04);
			border-radius: 4px;
			// padding-left: 8rem;
			line-height: 36rem;

			font-size: 18rem;
			font-weight: 400;
			color: #333333;

			.total-item {
				background-color: #fff;
				height: 100%;
			}

			.total-data-close {
				margin-left: 24rem;
				color: #fd4238;
				font-weight: bold;
			}

			.total-data-open {
				margin-left: 24rem;
				color: #68d86a;
				font-weight: bold;
			}
		}

		.PowerQuality-none {
			.w(280) !important;

			.val {
				.w(145) !important;
			}

			.key {
				width: auto !important;
				margin-left: 25rem;
				margin-right: 32rem;
			}
		}

		.data {
			.w(395);

			.details {
				.h(132);
				justify-content: space-between;
				margin-top: 23rem;

				.row {
					margin-bottom: 18rem;
				}

				.active {
					span {
						color: #fd4238;
					}
				}

				.key,
				.val {
					font-size: 14rem;
					color: #333333;
					font-weight: 400;
				}

				.key {
					.w(120);
					/*margin-right: 4rem;*/
				}

				.val {
					color: #0d94ff;
					.w(263);

					span {
						display: inline-block;
						width: 25%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;

			.location-right {
				.w(492);
				.h(236);
				position: absolute;
				right: 69rem;
				background-color: red;
				padding: 36rem 0 0 38rem;
				background: rgba(0, 43, 102, 0.04);

				.location-and {
					display: flex;
					align-items: center;
					height: 34rem;

					.location-img {
						width: 34rem;
						height: 34rem;
						margin-right: 5px;
					}

					img {
						width: 34rem;
						height: 34rem;
					}
				}

				.location-title {
					// font-size: 24px;

					font-size: 28rem;
					font-weight: bold;
					color: #68d86a;

					line-height: 30px;
				}

				.location-orag {
					font-size: 28rem;
					font-weight: bold;
					color: #f5aa00;

					line-height: 30px;
				}

				.location-item {
					margin-top: 35rem;
					.w(420);
					height: 63px;
					font-size: 16rem;
					font-weight: 400;
					color: #999999;
					word-wrap: break-word;
					word-break: break-all;
					overflow: hidden;
					/*这个参数根据需求来决定要不要*/
				}
			}
		}

		.name {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			border-bottom: 1px solid rgba(0, 0, 0, 0.15);
			padding-bottom: 8rem;
			margin-top: 20rem;
			padding-left: 17rem;
		}
	}

	.Loopst {
		width: 475rem;
	}

	.breaker {
		display: flex;
		width: 100%;
		height: 100%;
		// background-color: rgba(0, 43, 102, 0.04);
		padding-left: 8rem;

		span {
			font-size: 18rem;
			font-weight: bold;
		}

		.k {
			color: #333333;
			margin-right: 24rem;
		}

		.v {
			color: red;
		}

		.Handcart {
			color: #0d94ff;
		}

		.sate {
			padding-left: 325rem;
		}
	}

	.ored {
		margin-left: 24rem;
		color: #fd4238;
		font-weight: bold;
	}

	.oglad {
		margin-left: 24rem;
		color: #68d86a;
		font-weight: bold;
	}

	.obalck {
		color: #0d94ff;
		font-weight: bold;
	}
</style>
